const TEAM_CHAT_KEY_PREFIX = "team:";
const TEAM_CHAT_ID_PREFIX = "team_";
const CHAT_GRACE_PERIOD_MS = 30 * 24 * 60 * 60 * 1000;

function getMessageDate(message) {
  const epochTime = Number(message?.epochTime || 0);
  if (Number.isFinite(epochTime) && epochTime > 0) {
    return new Date(epochTime);
  }

  if (typeof message?.createdAt?.toDate === "function") {
    return message.createdAt.toDate();
  }

  return null;
}

function getMessageDateKey(message) {
  const date = getMessageDate(message);
  if (!date || !Number.isFinite(date.getTime())) return "";

  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");
}

function formatMessageDateLabel(message, now = new Date()) {
  const date = getMessageDate(message);
  if (!date || !Number.isFinite(date.getTime())) return "";

  const dateText = date.toLocaleDateString([], {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  const todayKey = getMessageDateKey({ epochTime: now.getTime() });
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayKey = getMessageDateKey({ epochTime: yesterday.getTime() });
  const messageDateKey = getMessageDateKey(message);

  if (messageDateKey === todayKey) return `Today · ${dateText}`;
  if (messageDateKey === yesterdayKey) return `Yesterday · ${dateText}`;
  return dateText;
}

function getRaceEntries(userRaces) {
  if (userRaces instanceof Map) return Array.from(userRaces.entries());
  if (Array.isArray(userRaces)) return userRaces.map((race) => [race?.legId, race]);
  if (userRaces && typeof userRaces === "object") return Object.entries(userRaces);
  return [];
}

function buildTeamChatKey({ raceId, legId, teamName }) {
  return `${TEAM_CHAT_KEY_PREFIX}${raceId}:${legId}:${teamName}`;
}

function buildTeamChatId(chatKey) {
  return `${TEAM_CHAT_ID_PREFIX}${encodeURIComponent(chatKey)}`;
}

function getEligibleTeamChats(userRaces, nowMs = Date.now()) {
  const chats = new Map();

  getRaceEntries(userRaces).forEach(([fallbackLegId, race]) => {
    const teamName = typeof race?.teamName === "string" ? race.teamName.trim() : "";
    if (!teamName || teamName === "noTeam") return;

    const raceEndMs = new Date(race?.raceInfo?.raceDateEnd).getTime();
    if (!Number.isFinite(raceEndMs) || raceEndMs + CHAT_GRACE_PERIOD_MS < nowMs) return;

    const raceId = race?.raceId;
    const legId = race?.legId || fallbackLegId;
    if (!raceId || !legId) return;

    const chatKey = buildTeamChatKey({ raceId, legId, teamName });
    const chatId = buildTeamChatId(chatKey);
    if (chats.has(chatId)) return;

    chats.set(chatId, {
      id: chatId,
      chatId,
      chatKey,
      raceId,
      legId,
      teamName,
      raceName: race?.raceInfo?.name || "",
      legName: race?.raceInfo?.legName || "",
      imageUrl: race?.raceInfo?.imageUrl || "",
    });
  });

  return Array.from(chats.values());
}

export {
  CHAT_GRACE_PERIOD_MS,
  buildTeamChatId,
  buildTeamChatKey,
  formatMessageDateLabel,
  getEligibleTeamChats,
  getMessageDateKey,
};
